var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "text-white rounded p-1 line-height-10 d-flex align-items-center",
      class: _vm.classes,
    },
    [
      _vm._t("default", function () {
        return [
          _c("i", { class: _vm.iconClasses }),
          _vm._v(" "),
          _c("small", { staticClass: "font-weight-bold mx-1" }, [
            _vm._v(_vm._s(_vm.displayedText)),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }